<template>
  <div>
    <v-card id="card" class="card-text px-1 rounded-0" color="" style="">
      <v-row>
        <v-col class="my-auto py-0">
          {{ item.Name }}
        </v-col>
        <v-col class="my-auto py-0" cols="auto">
          <v-btn icon @click="show = !show" class="card-text">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition class="">
        <div v-show="show" class="mt-1">
          <v-row>
            <v-col>
              <v-row>
                <v-col cols="6" class="my-auto"
                  >{{
                    $t("PeriodWorkDetails.tabs.detailsMorakhasi.AmountYear")
                  }}
                  : <span class="text-value">{{ item.AmountYear }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{
                    $t("PeriodWorkDetails.tabs.detailsMorakhasi.DaysYear")
                  }}
                  : <span class="text-value">{{ item.DaysYear }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{
                    $t("PeriodWorkDetails.tabs.detailsMorakhasi.AmountMonth")
                  }}
                  : <span class="text-value">{{ item.AmountMonth }}</span>
                </v-col>
                <v-col cols="6" class="my-auto"
                  >{{
                    $t("PeriodWorkDetails.tabs.detailsMorakhasi.DaysMonth")
                  }}
                  : <span class="text-value">{{ item.DaysMonth }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="auto py-0">
              <div style="width: 36px; height: 36px"></div>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>